/**
 * Sequence manager for coordinating async work with newer events.
 * Ensures only the most recent callback wins: invalidates in-flight work when a newer event arrives.
 *
 * - capture(): Call before starting async work; returns sequence id. If invalidate() runs before work completes, isStale(id) becomes true.
 * - invalidate(): Call when a newer event arrives; makes any in-flight work stale.
 * - isStale(id): True if capture() was superseded by invalidate().
 */
export interface LocationUpdateSequence {
	capture(): number
	invalidate(): void
	isStale(captured: number): boolean
}

export function createLocationUpdateSequence(): LocationUpdateSequence {
	let seq = 0
	return {
		capture: (): number => ++seq,
		invalidate: (): void => {
			seq++
		},
		isStale: (captured: number): boolean => captured !== seq,
	}
}

export const locationUpdateSequence = createLocationUpdateSequence()
